/**
 * ARENA — training-arena realism pass (2026-11-04). The concrete arena reads
 * as a real sports/training facility: stacked precast barrier blocks with
 * lifting eyes, corner guards and hazard-striped feet, LED perimeter boards,
 * sector signs, wall packs, drain channels, painted court lines and corner
 * spawn zones; grandstands, floodlight masts and a scoreboard beyond the
 * walls. All the work is in ./arenaKit.ts (shared with arena_xl / sandlot);
 * the contract bench is agent/bench-extras-arenas.mjs.
 */
import type * as THREE from "three";
import type { MapExtrasContext } from "../mapExtras.js";
import { arenaLayout, buildKit } from "./arenaKit.js";

export const mapIds = ["grid_arena"];

export function build(ctx: MapExtrasContext): THREE.Object3D | null {
  return buildKit(ctx, arenaLayout(ctx.map, ctx.lowSpec), "extras:grid_arena");
}
